import React, {useEffect, useLayoutEffect} from 'react';
import {ActivityIndicator, Platform, View} from 'react-native';

import {useNavigation, useRoute} from '@react-navigation/native';

import {colorPalette} from '../../../core/config/color.config';

import {DoctorConsultationProfile, HeaderBackLeft} from './../../views';
import {NavigationKey} from '../../navigations/config';
import {useGetPractitionerProfile} from '../../server/react-query/usePractitioner';

/**
 * Entry point for a doctor's shareable profile link (`/dr/:practitionerId`).
 * Only reachable when a patient session is already active - see
 * RootStackNavigator, where this screen is registered alongside the patient
 * MAIN_DRAWER. A logged-out open of the link never reaches this screen.
 */
const SharedDoctorProfileScreen = () => {
  const route = useRoute();
  const navigation = useNavigation();

  const practitionerId = (route.params as any)?.practitionerId as
    | string
    | undefined;

  const {data: practitioner, isError} = useGetPractitionerProfile({
    practitionerId: practitionerId ?? '',
  });

  const goToLanding = () => {
    navigation.navigate(NavigationKey.MAIN_DRAWER);
  };

  useLayoutEffect(() => {
    navigation.setOptions({
      headerShown: Platform.OS !== 'web',
      title: '',
      headerLeft: () => (
        <HeaderBackLeft
          label=" "
          iconName="left-white"
          navigationKey={NavigationKey.MAIN_DRAWER}
        />
      ),
      headerStyle: {
        borderBottomColor: 'transparent',
        elevation: 0,
        shadowOpacity: 0,
        backgroundColor: colorPalette.primary,
      },
    });
  }, [navigation]);

  useEffect(() => {
    if (!practitionerId || isError) {
      goToLanding();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [practitionerId, isError]);

  if (!practitioner) {
    return (
      <View
        style={{flex: 1, alignItems: 'center', justifyContent: 'center'}}>
        <ActivityIndicator size="large" color={colorPalette.primary} />
      </View>
    );
  }

  return (
    <DoctorConsultationProfile practitioner={practitioner} onClose={goToLanding} />
  );
};

export default SharedDoctorProfileScreen;
